import * as React from 'react'

import styles from './CardTag.module.css'

type CardTagProps = {
  tag: string
}

const CardTag: React.FC<CardTagProps> = ({ tag }) => (
  <div className={styles.textBadgeContainer}>{tag}</div>
)

export default CardTag
